import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveStopWordsMutationVariables = Types.Exact<{
  stopWords: ReadonlyArray<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type SaveStopWordsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveStopWords: boolean };


export const SaveStopWordsDocument = gql`
    mutation SaveStopWords($stopWords: [String!]!) {
  saveStopWords(stopWords: $stopWords)
}
    `;
export type SaveStopWordsMutationFn = Apollo.MutationFunction<SaveStopWordsMutationPage, SaveStopWordsMutationVariables>;

/**
 * __useSaveStopWordsMutation__
 *
 * To run a mutation, you first call `useSaveStopWordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStopWordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStopWordsMutation, { data, loading, error }] = useSaveStopWordsMutation({
 *   variables: {
 *      stopWords: // value for 'stopWords'
 *   },
 * });
 */
export function useSaveStopWordsMutation(baseOptions?: Apollo.MutationHookOptions<SaveStopWordsMutationPage, SaveStopWordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStopWordsMutationPage, SaveStopWordsMutationVariables>(SaveStopWordsDocument, options);
      }
export type SaveStopWordsMutationHookResult = ReturnType<typeof useSaveStopWordsMutation>;
export type SaveStopWordsMutationResult = Apollo.MutationResult<SaveStopWordsMutationPage>;
export type SaveStopWordsMutationOptions = Apollo.BaseMutationOptions<SaveStopWordsMutationPage, SaveStopWordsMutationVariables>;